export interface Credentials {
    email: string;
    password: string;
    auto: boolean;
    rememberLoginChecked: boolean;
}

export class CredentialsHelper {
    static create(): Credentials {
        return {
            email: '',
            password: '',
            auto: false,
            rememberLoginChecked: false,
        };
    }

    static newFromJSON(json: string): Credentials {
        let credentials: Credentials = null;
        try {
            credentials = CredentialsHelper.fromObject(JSON.parse(json));
        } catch (e) {
            console.error('Invalid credentials JSON.', e);
        }
        return credentials;
    }

    static fromObject(obj: Object = {}): Credentials {
        const credentials = CredentialsHelper.create();
        return Object.assign(credentials, obj);
    }
}
